<template>
  <div
    :class="[
      classes,
      {
        'raised-bottom': viewport === 'mobile' && isPdpPage,
      },
    ]"
    :data-preload="[$options.name]"
  >
    <div class="inner">
      <Toast />
    </div>

    <CookiesMain />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Toast from 'Components/02-molecules/toast/Toast';
import CookiesMain from 'Components/03-organisms/cookies-main/CookiesMain';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'ViewportBottom',
  components: {
    Toast,
    CookiesMain,
  },
  mixins: [globalMixin],
  data() {
    return {
      showCookiesBar: false,
    };
  },
  computed: {
    ...mapState('core', { viewport: ({ viewport: { range } }) => range }),
    ...mapState('productsList', {
      isPdpPage: (state) =>
        state?.component ? state.component === 'ProductDetails' : false,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import 'variables/breakpoints';
@import 'mixins';

.viewportBottom {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9999;

  &.raised-bottom {
    bottom: 85px;
  }
}

.inner {
  @include pageWidth;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: var(--space-1);
}
</style>
